module.exports = __webpack_public_path__ + "static/media/loading4.7dedad8b.gif";